<template>
    <div>
       

        <b-row class="mb-3">
            <b-col cols="12">
                <div class="d-flex flex-row align-items-center justify-content-between">
                    <div>

                    </div>
                    <b-form-group class="text-md-center" label="">
                        <b-form-radio-group @change="changeItemType" class="" size="lg" id="radio-group-2" v-model="ItemType" name="radio-sub-component">
                            <b-form-radio disabled class="mx-md-5" size="lg" value="Food">Food</b-form-radio>
                            <b-form-radio disabled class="mx-5" size="lg" value="Drink">Drink</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group>
                        <b-form-checkbox
                                id="checkbox-1"
                                v-model="openItem"
                                name="checkbox-1"
                                value="open"
                                unchecked-value="close"
                                disabled
                        >
                            Open Item
                        </b-form-checkbox>
                    </b-form-group>

                </div>
            </b-col>
            <b-col cols="12" v-if="!isOpen">
                <div class="overflow-auto mb-3">
                    <b-button-group class="groupsButtons" size="sm">
                        <b-button
                                style="font-size: 0.9rem"
                                v-for="item in menuTypes"
                                class="py-4 px-3"
                                @click="getFoods(item, ItemType)"
                                :class="item.checked ? 'activeBtn' : 'deactiveBtn'"
                                disabled
                        >
                            {{item.MenuType}}
                        </b-button>
                    </b-button-group>
                </div>
            </b-col>
            <b-col cols="12" v-if="!isOpen">
                <div class="multiselect-availability">
                    <Multiselect
                            class="miniMulti"
                            v-model="ItemCategory"
                            :options="foods"
                            v-validate="'required'"
                            name="item"
                            placeholder="انتخاب کنید"
                            @input="changeFood"
                            disabled
                    />
                </div>
            </b-col>
        </b-row>
        <b-row class="mb-3" v-if="!isOpen">
            <b-col cols="12" md="6">
                <div class="w-100 h-100 p-2" style="border: 1px solid #e4e7ea; border-radius: 4px" v-if="ItemCategory && priceTypes.length">
                    <b-form-group>
                        <b-form-radio-group stacked class="my-2" v-validate="'required'" size="lg" id="radio-group-3" v-model="PriceType" name="Price">
                            <b-form-radio v-for="item in priceTypes" class="mb-5" :value="item.value">
                                    <span v-if="item.comment" class="font-weight-bold">
                                        {{item.comment}}
                                    </span>
                                <span class="ml-3 text-muted">
                                        ${{item.value}}
                                        <span v-if="item.value === 0" class="mx-2">
                                            (FREE)
                                        </span>
                                    </span>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <div v-if="this.ItemCategory.Alcoholic" class="h5 font-weight-bold mb-0" style="color: #4748cc">
                        * Alcoholic: VERIFY AGE *
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <div v-if="modifiers.length" class="overflow-auto h-100 p-2" style="border: 1px solid #e4e7ea; border-radius: 4px">
                    <h5 class="font-weight-bold mb-0">Modifiers</h5>
                    <b-button-group size="md">
                        <b-button
                                v-for="item in modifiers"
                                :class="{
                                     'activeBtn': item.selected,
                                        'deactiveBtn': !item.selected
                                }"
                                @click="selectModifier(item)"
                        >
                            <span :class="!item.selected && item.hasError ? 'error-btn-animated' : 'text-dark'">
                                {{item.ModifierCategory}}
                            </span>
                        </b-button>
                    </b-button-group>
                    <div>
                        <div class="my-2">
                                <span style="color: rgba(0,0,71,0.82)">
                                    <span v-if="activeModifier.IsOptional">Optional</span>
                                    <span v-else>Required</span>
                                </span>
                            <span style="color: rgba(0,0,71,0.82)">
                                    {{' ( ' + activeModifier.ChoiceOption + '  ' + activeModifier.ChoiceNumber +' ) '}}
                                </span>
                        </div>
                        <div>
                            <p class="text-danger font-weight-bold">
                                {{activeModifier.errorText}}
                            </p>
                        </div>
                        <div>
                            <div v-if="activeModifier.ModifierItems.length < 6">
                                <p v-for="item in activeModifier.ModifierItems" :key="item.ModifierName">
                                    <b-button
                                        :pressed="item.checked"
                                        @click="changeModifierOption(item, activeModifier)"
                                        variant="outline-warning"
                                        class="modifier-btn w-100 d-flex justify-content-between align-items-center mb-2 modifier-btn"
                                        style="border: 1px dashed black; border-radius: 4px; color: black; font-size: 1.1rem"
                                    >
                                        <div>
                                            <span>{{item.ModifierName}}</span>
                                            <span v-if="item.ModifierDesc !== ''">{{' - '}}</span>
                                            <span style="font-style: italic" v-if="item.ModifierDesc !== ''">{{item.ModifierDesc}}</span>
                                        </div>
                                        <span class="mx-3" v-if="item.itemPrice !== '' || item.itemPrice !== null">{{'+$' + item.Price.toFixed(2)}}</span>
                                    </b-button>
                                </p>
                            </div>
                            <div v-else>
                                <b-row>
                                    <b-col cols="6" v-for="item in activeModifier.ModifierItems" :key="item.ModifierName">
                                        <b-button
                                            :pressed="item.checked"
                                            @click="changeModifierOption(item, activeModifier)"
                                            variant="outline-warning"
                                            class="modifier-btn w-100 d-flex justify-content-between mb-2 mt-2"
                                            style="border: 1px dashed black; border-radius: 4px; color: black; font-size: 1.1rem"
                                        >
                                            <div>
                                                <span>{{item.ModifierName}}</span>
                                                <span v-if="item.ModifierDesc !== ''">{{' - '}}</span>
                                                <span style="font-style: italic" v-if="item.ModifierDesc !== ''">{{item.ModifierDesc}}</span>
                                            </div>
                                            <span class="mx-3" v-if="item.itemPrice !== '' || item.itemPrice !== null">{{'+$' + item.Price.toFixed(2)}}</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row class="mb-3">
            <b-col cols="12" lg="6" v-if="isOpen">
                <b-form-group>
                    <b-input-group class="mx-1" prepend="Description">
                        <b-input disabled readonly v-model="currentItemName"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group v-if="showPrinterField">
                    <b-input-group prepend="Printstation">
                        <b-select v-model="PrinterID" :options="printers" text-field="PrinterName" value-field="PrinterID" name="Printstation"/>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" v-if="isOpen">
                <b-form-group>
                    <b-input-group prepend="Unit Price($)">
                        <numeric-input no-seprator v-model="openItemUnitPrice" v-validate="'required'" name="unit price"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group>
                    <b-input-group prepend="Display station">
                        <b-select v-model="KDS" :options="kdsList" v-validate="'required'" name="Display station"/>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <div v-if="hasCourse && orderTypeId === 2" class="d-flex align-items-center mb-3 flex-nowrap">
                    <b-btn size="sm" variant="danger" @click="reduceCourse">
                        <font-awesome-icon icon="minus" class="mx-1 align-middle"/>
                    </b-btn>
                    <b-input-group class="mx-1" prepend="Course">
                        <numeric-input no-seprator :decimal="false" v-model="CourseNo" name="Course"/>
                    </b-input-group>
                    <b-btn size="sm" variant="danger" @click="addCourse">
                        <font-awesome-icon icon="plus" class="mx-1 align-middle"/>
                    </b-btn>
                </div>

                <div class="d-flex align-items-center flex-nowrap mb-3">
                    <b-btn size="sm" variant="danger" @click="Quantity = Quantity - 1">
                        <font-awesome-icon icon="minus" class="mx-1 align-middle"/>
                    </b-btn>
                    <b-input-group class="mx-1" prepend="Quantity">
                        <numeric-input no-seprator :decimal="false" v-model="Quantity" v-validate="quantityValidation" name="quantity"/>
                    </b-input-group>
                    <b-btn size="sm" variant="danger" @click="Quantity = Quantity + 1">
                        <font-awesome-icon icon="plus" class="mx-1 align-middle"/>
                    </b-btn>
                </div>

                <div v-if="!isOpen">
                    <p class="mb-0 mt-3 text-danger font-weight-bold" v-if="remainCount !== ''">
                        <span v-if="remainCount == '0'">ZERO left</span>
                        <span v-else>
                            Only {{remainCount}} Left
                        </span>
                    </p>
                    <p v-if="modifierValidation" class="font-weight-bold mt-3 text-danger">
                        Please select the missing modifier(s).
                    </p>
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <b-input-group prepend="Special Instructions *">
                    <b-textarea v-model="Description"/>
                </b-input-group>
                <p class="mt-1 text-danger" style="font-style: italic">
                    * Text input will be visible to customers.
                </p>
            </b-col>
        </b-row>
        <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
            <ul class="m-0 px-1">
                <li v-for="err in errors.all()" :key="err">{{err}}</li>
            </ul>
        </b-alert>

        <b-row class="flex-grow-1 mt-3">
            <b-col cols="4">
                <b-btn variant="warning" block class="text-nowrap" :disabled="loading || modifierValidation || remainCount === '0'" @click="editItem">
                    <span v-if="loading">
                        <font-awesome-icon spin icon="circle-notch" class="align-middle"/>
                    </span>
                    <span v-else>Update item</span>
                </b-btn>
            </b-col>

            <b-col cols="4">
                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="loadingBtn" @click="cancel">
                    <span v-if="loading">
                        <font-awesome-icon spin icon="circle-notch" class="align-middle"/>
                    </span>
                    <span v-else>Cancel</span>
                </b-btn>
            </b-col>

            <b-col cols="4">
                <b-btn variant="danger" block class="text-nowrap" @click="deleteItem">
                    <span>Delete Item
                    </span>
                </b-btn>
            </b-col>
        </b-row>

        <b-modal body-class="p-0" hide-header hide-footer v-model="confirmationDeleteModal">
            <b-card class="m-0" no-body>
                <b-card-header>
                    <span>Delete Item</span>
                </b-card-header>
                <b-card-body>
                    <div>
                        <p>Do you want to delete this item?</p>
                    </div>
                    <div class="d-flex flex-row justify-content-start">
                        <b-btn class="processBtnModal" @click="deleteItem">
                            YES, Proceed with delete
                        </b-btn>
                        <b-btn class="cancelBtnModal ml-2" @click="confirmationDeleteModal = !confirmationDeleteModal">No, Never mind</b-btn>
                    </div>
                </b-card-body>
            </b-card>
        </b-modal>
    </div>
</template>
<script>
    import Multiselect from '../shared/multiselect'
    import NumericInput from "../shared/NumericInput";
    export default {
        name: 'addItem',
        components: {
            Multiselect,
            NumericInput
        },
        props: {
            value: {required: true, type: Object, default: {}},
            isLocal: {type: Boolean, default: false},
            selectedItems: {required: false},
            itemIndex: {required: true},
            isSpecial: {
                type: Boolean, default: false
            },
            orderType: {required: false},
            selectedOrderID: {
                required: false
            },
            orderTypeId: {
                required: false
            },
            hasCourse: {
                required: false,
                type: Boolean
            }
        },
        data () {
            return {
                CourseNo: '',
                ItemType: 'Food',
                menuTypes: [],
                foods: [],
                ItemCategory: null,
                PriceType: null,
                remainCount: '',
                modifiers: [],
                Quantity: 1,
                Description: '',
                loading: false,
                loadingBtn: false,
                confirmationDeleteModal: false,
                openItemType: 'Open Item Alcoholic',
                openItemUnitPrice: '',
                openItems: [],
                OpenItemCategory: null,
                openItem: 'close',
                currentItemName: null,
                openItemUnitPrice: null,
                openItemId: null,
                openItemAlcolic: false,
                kdsList: [],
                KDS: '',
                printers: [],
                PrinterID: ''

            }
        },
        mounted() {
            this.loadItem(this.value)
            this.Quantity = this.value.Qty
            this.Description = this.value.DetailDescription
            // this.getAllMenuTypes(this.ItemType)
        },
        computed: {
            showPrinterField () {
                return this.printers.length === 1 ? false : true
            },
            isOpen () {
                return this.openItem === 'open'
            },
            quantityValidation () {
                if (this.remainCount === '') {
                    return {
                        required: true,
                        min_value: 1
                    }
                } else if (this.remainCount == '0') {
                    return {
                    }
                } else {
                    return {
                        required: true,
                        max_value: this.remainCount,
                        min_value: 1
                    }
                }
            },
            priceTypes () {
                return this.ItemCategory ?
                    this.ItemCategory.availablePrices.filter(i => i.value >= 0)
                    : []
            },
            activeModifier () {
                return this.modifiers.find(item => item.selected)
            },
            modifierValidation () {
                if (!this.modifiers.length) {
                    return false
                } else {
                    return this.modifiers.some(i => i.hasError)
                }
            },
        },
        methods: {
            reduceCourse () {
                // if (this.CourseNo > 1) {
                //     this.CourseNo = this.CourseNo - 1
                //     if (this.CourseNo === 1) {
                //         this.CourseNo = ''
                //     }
                // }
                if (this.CourseNo >= 1) {
                    this.CourseNo = this.CourseNo - 1
                    if (this.CourseNo === 0) {
                        this.CourseNo = ''
                    }
                }
            },
            addCourse () {
                if (this.CourseNo === '') {
                    this.CourseNo = 1
                } else {
                    this.CourseNo = this.CourseNo + 1
                }
            },
            loadItem (value) {
                if (value.CourseNo) {
                    this.CourseNo = value.CourseNo.split('C')[1]
                } else {
                    this.CourseNo = ''
                }
                if (value.open) {
                    this.openItem = 'open'
                    this.currentItemName = value.Name
                    this.openItemUnitPrice = value.PriceType
                    this.openItemId = value.ItemID
                    this.openItemAlcolic = value.Alcoholic
                    Promise.all([
                        this.GetRestaurantKDSs({
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }, value),
                        this.getPrinters({
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            // UserID: localStorage.getItem('userID')
                        }, value)
                    ]).then(res => {

                    })
                } else {
                    this.KDS = ''
                    this.PrinterID = 0
                    this.openItem = 'close'
                }
                this.ItemType = value.ItemType
                if (this.openItem === 'close') {
                    this.getAllMenuTypes(this.ItemType)
                }
            },
            GetRestaurantKDSs (object, value) {
                return this.$api.getRestaurant.GetRestaurantKDSs(object).then(res => {
                    if (res.success) {
                        res.results.RestaurantKDS.forEach(item => {
                            item.value = item.KDSID
                            item.text = item.KDS
                        })
                        const list = res.results.RestaurantKDS
                        this.kdsList = list
                        const findKds = list.find(item => item.value == value.KDS)
                        if (findKds) {
                            this.KDS = findKds.KDSID
                        }
                    }
                })
            },
            getPrinters (object, value) {
                this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
                    if (res.success) {
                        this.printers = [{PrinterName: 'None', PrinterID: 0}].concat(res.results.RestaurantPrinter.filter(i => i.PrintTaskID !== 2))
                        const findPrinter = this.printers.find(item => item.PrinterID == value.PrinterID)
                        if (findPrinter) {
                            this.PrinterID = findPrinter.PrinterID
                        }
                    }
                })
            },
            getAllMenuTypes (ItemType) {
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType
                }
                return this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
                    if (res.success) {
                        this.foods = []
                        this.food = null
                        this.PriceType = null
                        this.ItemCategory = null
                        this.menuTypes = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
                        this.menuTypes.forEach(item => {
                            if (item.MenuTypeID == this.value.SelectedMenuType) {
                                this.$set(item, 'checked', true)
                            } else {
                                this.$set(item, 'checked', false)
                            }
                        })
                        this.getFoods(this.value.SelectedMenuType, this.value.ItemType)
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {})
            },
            changeItemType (itemType) {
                this.getAllMenuTypes(itemType)
                this.resetModifiers()
            },
            getFoods (menutype, ItemType) {
                this.menuTypes.forEach(i => {
                    if (i.MenuTypeID === menutype) {
                        i.checked = true
                    } else {
                        i.checked = false
                    }
                })
                const model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType,
                    MenuTypeID: menutype
                }
                this.resetModifiers()
                return this.$api.getRestaurant.GetRestaurantItems(model).then(res => {
                    if (res.success) {
                        this.ItemCategory = null
                        this.PriceType = null
                        this.foods = res.results.RestaurantItems
                        this.foods.forEach(item => {
                            item.value = item.ItemID
                            item.availablePrices = [
                                {text: 'Price', value: item.Price, comment: item.PriceComment},
                                {text: 'Price1', value: item.Price1, comment: item.Price1Comment},
                                {text: 'Price2', value: item.Price2, comment: item.Price2Comment},
                                {text: 'Price3', value: item.Price3, comment: item.Price3Comment},
                                {text: 'Price4', value: item.Price4, comment: item.Price4Comment},
                            ]
                            if (this.addPlusSymbol(item)) {
                                item.priceSymbol = ' + '
                            } else {
                                item.priceSymbol = ''
                            }
                            if (item.Price !== -999999) {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' - ' + '$' + item.Price + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            } else {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' ' + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            }
                        })
                        const findItem = this.foods.find(item => item.ItemID == this.value.ItemID)
                        if (findItem) {
                            this.ItemCategory = findItem
                            this.PriceType = this.value.PriceTypeValue
                            this.getAllModifiers(findItem)
                            this.getItemAvailabilty(findItem)
                        }
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            addPlusSymbol (item) {
                if (item.availablePrices.filter(i => i.value > 0).length > 1) {
                    return true
                }
                if (item.HasModifier) {
                    return true
                }
                return false
            },
            changeFood (food) {
                if (food) {
                    this.selectPriceType()
                    this.getItemAvailabilty(food)
                    this.getAllModifiers(food)
                } else {
                    this.remainCount = ''
                    this.PriceType = ''
                }
            },
            selectPriceType () {
                if (this.priceTypes.length) {
                    this.PriceType = this.priceTypes[0].value
                } else {
                    this.PriceType = ''
                }
            },
            getAllModifiers (food) {
                if (food) {
                    const model = {
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        // UserID: localStorage.getItem('userID'),
                        OrderID: this.selectedOrderID,
                        FoodID: this.ItemType === 'Food' ? food.ItemID : 0,
                        DrinkID: this.ItemType === 'Drink' ? food.ItemID: 0
                    }
                    return this.$api.getRestaurant.GetModifierByFoodID(model).then(res => {
                        if (res.success) {
                            let optional = res.results.filter(i => i.IsOptional)
                            let required = res.results.filter(i => !i.IsOptional)
                            this.modifiers = [...required, ...optional]
                            let currentModifiers = this.value.ModifierIDs.replace(/#/g, ' ').split(' ')
                            this.modifiers.forEach((item, index) => {
                                this.$set(item, 'hasError', false)
                                item.errorText = ''
                                // if (!item.IsOptional) {
                                //     if (item.ChoiceOption === 'Exactly') {
                                //         item.errorText = 'Please select exactly ' + item.ChoiceNumber + ' items'
                                //         this.$set(item, 'hasError', true)
                                //     } else if (item.ChoiceOption === 'Minimum') {
                                //         this.$set(item, 'hasError', true)
                                //         item.errorText = 'Please select Mininmum ' + item.ChoiceNumber + ' choices'
                                //     } else if(item.ChoiceOption === 'Maximum') {
                                //         this.$set(item, 'hasError', true)
                                //         item.errorText = 'Please select Maximum ' + item.ChoiceNumber + ' choices'
                                //     }
                                // }
                                // else {
                                //     if (item.ChoiceOption === 'Exactly') {
                                //         item.errorText = ''
                                //         this.$set(item, 'hasError', false)
                                //     } else if (item.ChoiceOption === 'Minimum') {
                                //         item.errorText = ''
                                //         this.$set(item, 'hasError', false)
                                //     } else if(item.ChoiceOption === 'Maximum') {
                                //         item.errorText = ''
                                //         this.$set(item, 'hasError', false)
                                //     }
                                // }
                                if (index === 0) {
                                    this.$set(item, 'selected', true)
                                }
                                else {
                                    this.$set(item, 'selected', false)
                                }
                                item.ModifierItems.forEach(ch => {
                                    ch.value = ch.ModifierID
                                    ch.text = ch.ModifierName
                                    

                                    let find = currentModifiers.find(i => i.trim() == ch.ModifierID)
                                    if (find) {
                                        this.$set(ch, 'checked', true)
                                    } else {
                                        this.$set(ch, 'checked', false)
                                    }
                                    // this.$set(ch, 'checked', false)
                                })
                            })
                        } else {
                            this.$showError(res.message)
                        }
                    })
                }
            },
            selectModifier (modifier) {
                this.modifiers.forEach((item) => {
                    item.selected = false
                })
                modifier.selected = true
            },
            resetModifiers () {
                this.modifiers = []
            },
            changeModifierOption (modifier, modifierGroup) {
                modifier.checked = !modifier.checked
                if (!modifierGroup.IsOptional) {
                    //check at lease one modifier options
                    let ChoiceNumber = modifierGroup.ChoiceNumber
                    let ChoiceOption = modifierGroup.ChoiceOption
                    if (ChoiceOption === 'Exactly') {
                        let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
                        if (!checkModifier.length) {
                            modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
                            modifierGroup.hasError = true
                        } else {
                            if (checkModifier.length !== +ChoiceNumber) {
                                modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
                                modifierGroup.hasError = true
                            } else {
                                modifierGroup.errorText = ''
                                modifierGroup.hasError = false
                            }
                        }
                    }
                    else if (ChoiceOption === 'Minimum') {
                        let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
                        if (!checkModifier.length) {
                            modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
                            modifierGroup.hasError = true
                        } else {
                            if (checkModifier.length < +ChoiceNumber) {
                                modifierGroup.errorText = 'Please select Mininmum ' + ChoiceNumber + ' choices'
                                modifierGroup.hasError = true
                            } else {
                                modifierGroup.errorText = ''
                                modifierGroup.hasError = false
                            }
                        }
                    }
                    else if (ChoiceOption === 'Maximum') {
                        let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
                        if (!checkModifier.length) {
                            modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
                            modifierGroup.hasError = true
                        } else {
                            if (checkModifier.length > +ChoiceNumber) {
                                modifierGroup.errorText = 'Please select Maximum ' + ChoiceNumber + ' choices'
                                modifierGroup.hasError = true
                            } else {
                                modifierGroup.errorText = ''
                                modifierGroup.hasError = false
                            }
                        }
                    }
                }
                else {
                    let ChoiceNumber = modifierGroup.ChoiceNumber
                    let ChoiceOption = modifierGroup.ChoiceOption
                    if (ChoiceOption === 'Exactly') {
                        let checkModifier = modifierGroup.ModifierItems.filter(i => i.checked)
                        if (!checkModifier.length) {
                            modifierGroup.errorText = ''
                            modifierGroup.hasError = false
                        } else {
                            if (checkModifier.length !== +ChoiceNumber) {
                                modifierGroup.errorText = 'Please select exactly ' + ChoiceNumber + ' items'
                                modifierGroup.hasError = true
                            } else {
                                modifierGroup.errorText = ''
                                modifierGroup.hasError = false
                            }
                        }
                    }
                }
            },
            getItemAvailabilty (food) {
                const model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    ItemType: this.ItemType,
                    ItemID: food.ItemID
                }
                return this.$api.getRestaurant.GetItemAvailability(model).then(res => {
                    if (res.success) {
                        let results = res.results
                        if (results.Total_Remain) {
                            if (+results.Total_Remain < 0) {
                                this.remainCount = '0'
                            } else {
                                if (this.selectedItems && this.selectedItems.length) {
                                    const findItem = this.selectedItems.filter(i => ItemID.ItemID === i.ItemID)
                                    if (findItem.length) {
                                        this.remainCount = (results.Total_Remain - this.totalQty(findItem) + +this.value.Qty).toString()
                                    }
                                } else {
                                    this.remainCount = results.Total_Remain
                                }
                            }
                        } else {
                            this.remainCount = ''
                        }
                    }
                })
            },
            totalQty (items) {
                return items.reduce(function (acc, current) {
                    return Number(acc) + Number(current.Qty)
                }, 0);
            },
            findPriceComment (prices) {
                const find = prices.find(item => item.value == this.PriceType)
                return find ? find.comment : ''
            },
            findPriceField (prices) {
                const find = prices.find(item => item.value == this.PriceType)
                return find ? find.text : ''
            },
            cancel () {
                this.$emit('cancelEditItem', false)
            },
            deleteItem () {
                //delete item
                this.$emit('deleteItem', this.itemIndex)
            },
            editItem () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        let ModifierIDs = []
                        let ModifierNames = []
                        let ModifierNamesSecondLang = []

                        this.modifiers.forEach(item => {
                            item.ModifierItems.forEach(ch => {
                                if (ch.checked) {
                                    ModifierIDs.push(ch.ModifierID)
                                    ModifierNames.push(ch.ModifierName)
                                    if(ch.ModifierName_SecondLang != ""){
                                        ModifierNamesSecondLang.push(ch.ModifierName_SecondLang)
                                    }else{
                                        ModifierNamesSecondLang.push(ch.ModifierName)
                                    }

                                }
                            })
                        })
                        let model = {}
                        if (this.openItem === 'open') {
                            model = {
                                IKey: 0,
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                // UserID: localStorage.getItem('userID'),
                                OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
                                FoodId: this.ItemType === 'Food' ? this.openItemId : 0,
                                DrinkID: this.ItemType === 'Drink' ? this.openItemId : 0,
                                Qty: this.Quantity,
                                PriceType: this.openItemUnitPrice,
                                PriceTypeValue: '',
                                DetailDescription: this.Description,
                                ModifierIDs: '',
                                ModifierNames: '',

                                Name: this.currentItemName,
                                ItemName_SecondLang: '',
                                PriceComment: '',
                                ItemID: this.openItemId,
                                Alcoholic: this.openItemAlcolic,
                                SelectedMenuType: '',
                                Price: this.openItemUnitPrice,
                                ItemType: this.ItemType,
                                totalPrice: (this.openItemUnitPrice * this.Quantity).toFixed(2),
                                open: true,
                                CourseNo: this.orderTypeId === 2 && this.CourseNo ?  ('C' + this.CourseNo) : '',
                                KDS: this.KDS,
                                PrinterID: this.PrinterID

                            }
                        } else {
                            model = {
                                IKey: 0,
                                RestaurantID: this.$store.state.selectedRestaurantId,
                                // UserID: localStorage.getItem('userID'),
                                OrderID: !this.selectedOrderID ? 0 : this.selectedOrderID,
                                FoodId: this.ItemType === 'Food' ? this.ItemCategory.ItemID : 0,
                                DrinkID: this.ItemType === 'Drink' ? this.ItemCategory.ItemID : 0,
                                Qty: this.Quantity,
                                PriceType: this.findPriceField(this.priceTypes),
                                PriceTypeValue: this.PriceType,
                                DetailDescription: this.Description,
                                ModifierIDs: ModifierIDs.length ? ('#' + ModifierIDs.join('#')) : '',
                                ModifierNames: ModifierNames.length ? (ModifierNames.join(',')) : '',
                                ModifierNamesSecondLang: ModifierNamesSecondLang.length ? ModifierNamesSecondLang.join(',') : '',

                                Name: this.ItemCategory.ItemName,
                                ItemName_SecondLang: this.ItemCategory.ItemName_SecondLang,

                                PriceComment: this.findPriceComment(this.priceTypes),
                                ItemID: this.ItemCategory.ItemID,
                                Alcoholic: this.ItemCategory.Alcoholic,

                                SelectedMenuType: this.value.SelectedMenuType,
                                Price: this.ItemCategory.Price,
                                ItemType: this.ItemType,
                                totalPrice: this.totalPrice().toFixed(2),
                                open: false,
                                CourseNo: this.orderTypeId === 2 && this.CourseNo ?  ('C' + this.CourseNo) : '',
                                KDS: -1,
                                PrinterID: -1
                            }
                        }
                        this.$emit('editItemFinaly', {
                            model,
                            itemIndex: this.itemIndex
                        })
                    }
                })
            },
            priceSelectedModifiers () {
                let modifierOptions = []
                this.modifiers.forEach(item => {
                    item.ModifierItems.forEach(ch => {
                        if (ch.checked) {
                            modifierOptions.push(ch)
                        }
                    })
                })
                // Price
                return modifierOptions.reduce(function (acc, current) {
                    return Number(acc) + Number(current.Price)
                }, 0);

            },
            totalPrice () {
                return (this.PriceType + this.priceSelectedModifiers()) * this.Quantity
            }
        }
    }
</script>
<style scoped lang="scss">
.modifier-btn:focus{
  background-color: white;
}
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #959a9f !important;
        color: #959a9f !important;
    }
    .groupsButtons{
        .disabled{
            /*background: #fff !important;*/
            border-color: #c4c9ce !important;
            /*color: #c4c9ce !important;*/
        }
    }
    select{
        option{
            span#itemName{
                font-weight: bold !important;
                color: red !important;
            }
        }
    }

    .error-btn-animated{
        animation: color 1s infinite;
        animation-fill-mode: forwards;
    }

    @keyframes color {
        from {color: #fff;}
        to {color: #000}
    }

</style>
